import { render, staticRenderFns } from "./DeliverDetail.vue?vue&type=template&id=7d0ae197&scoped=true"
import script from "./DeliverDetail.vue?vue&type=script&lang=js"
export * from "./DeliverDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliverDetail.vue?vue&type=style&index=0&id=7d0ae197&prod&lang=css"
import style1 from "./DeliverDetail.vue?vue&type=style&index=1&id=7d0ae197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ae197",
  null
  
)

export default component.exports